import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "24",
  fill: "none",
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 19V3a3 3 0 0 1 3-3h8a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 18 7v3a1 1 0 1 1-2 0V8h-5a1 1 0 0 1-1-1V2H3a1 1 0 0 0-1 1v16l.005.099A1 1 0 0 0 3 20h6a1 1 0 1 1 0 2H3a3 3 0 0 1-2.985-2.703zm9-4a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zm2-4a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM7 7a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm5-1h2.586L12 3.414z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.429 13a4.43 4.43 0 0 1 4.113 6.071 4.4 4.4 0 0 1-.334.664l2.5 2.5a1 1 0 0 1-1.415 1.413l-2.485-2.485a4.433 4.433 0 0 1-5.537-.629 4.43 4.43 0 0 1 .053-6.264A4.43 4.43 0 0 1 16.43 13m0 2a2.428 2.428 0 1 0 .001 4.856A2.428 2.428 0 0 0 16.43 15"
    }, null, -1)
  ]))]))
}
export default { render: render }